import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable, tap } from 'rxjs';
import { ServicesService } from './services.service';

@Injectable({
  providedIn: 'root'
})
export class CanUseCustomerFeatureGuard  {
  protected servicesService = inject(ServicesService);
  protected router = inject(Router);


  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const { featureKey } = route.data;
    if (!featureKey) {
      console.log('WARNING: CanUseCustomerFeatureGuard needs a featureKey argument');
      return true;
    }

    return this.servicesService.currentCustomer()
      .pipe(
        map((customer) => this.servicesService.customerHasActiveFeature(customer, featureKey)),
        tap((hasFeature) => {
          if (!hasFeature) {
            this.router.navigate(['/feature-not-enabled', featureKey])
          }
        })
      )
  }

}
